export default __webpack_public_path__ + "static/media/Headdress of the Hell Walker.93bd9c62.jpg";